// @flow

import {GraphData, Language, RiskRating, RiskSummary, CompaniesSortOption, TabDataFlags} from '@/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {mergeAll, path} from 'ramda'
import {appActions, appSelectors, portfoliosSelectors, uiActions, portfoliosActions} from '@/store'

import EventsGraph from '@/views/events-graph'
import DonutChart from '@/elements/donut-chart'
import Section from '@/elements/section'

import CompaniesAnalysis from './companies'
import {isAnyTabDataLoaded} from '@/views/util'

type Props = {
  l: Language,
  fetchPortfolioCompaniesByRiskType: () => void,
  graphData: Array<GraphData>,
  portfolioName: string,
  riskSummary: RiskSummary,
  setPortfolioCompaniesByRiskTypePageNumber: (number) => void,
  setPortfolioCompaniesByRiskTypeSortOptions: (CompaniesSortOption) => void,
  toggleRiskFilter: (RiskRating) => void,
  currentRiskLevel: RiskRating,
  tabDataFlags: TabDataFlags,
  fetchAnalysisTabInitialData: () => void,
  fetchCommonTabsData: () => void,
  updateGraph: () => void,
  isLoading: boolean,
}

const checkAndFetchData = (props) => {
  // call apis to fetch this tab data
  if (!props.tabDataFlags.isAnalysisDataLoaded && !props.isLoading) {
    // fetch common tab data if no tab is loaded yet
    if (!isAnyTabDataLoaded(props.tabDataFlags)) {
      props.fetchCommonTabsData()
    }
    // fetch graph data if home tab is not loaded yet
    if (!props.tabDataFlags['isHomeDataLoaded']) {
      props.updateGraph()
    }
    // fetch this tab data
    props.fetchAnalysisTabInitialData()
  }
}

const donutSegmentClick = (props: Props) => ({riskLevel}) => {
  props.toggleRiskFilter(riskLevel)
  props.setPortfolioCompaniesByRiskTypePageNumber(0)
  props.setPortfolioCompaniesByRiskTypeSortOptions()
  props.fetchPortfolioCompaniesByRiskType()
}

const renderCharts = (props: Props) => {
  const ratingInfo = [{
    name: props.l('Very low risk'),
    colour: '#00A44F',
    riskLevel: 'A',
    value: props.riskSummary.bandACount,
  }, {
    name: props.l('Low risk'),
    colour: '#86C440',
    riskLevel: 'B',
    value: props.riskSummary.bandBCount,
  }, {
    name: props.l('Moderate risk'),
    colour: '#FFC731',
    riskLevel: 'C',
    value: props.riskSummary.bandCCount,
  }, {
    name: props.l('High risk'),
    colour: '#F68E1E',
    riskLevel: 'D',
    value: props.riskSummary.bandDCount,
  }, {
    name: props.l('Not rated'),
    colour: '#EA2127',
    riskLevel: 'E',
    value: props.riskSummary.bandECount,
  }]

  return (
    <Section header={props.l('Risk Analysis')}>
      <div className="row">
        <div className={props.riskSummary.totalCompanies && props.riskSummary.totalCompanies > 0 ? 'col-md-9' : 'col-md-12'}>
          <EventsGraph />
        </div>
        {props.riskSummary.totalCompanies > 0
          ? <div className="col-md-3 no-padding">
            <DonutChart data={ratingInfo} segmentClick={donutSegmentClick(props)} riskLevel={props.currentRiskLevel}/>
          </div> : null}
      </div>
    </Section>
  )
}

export class RawAnalysisPage extends Component<Props> {
  render = () => (
    <div>
      {renderCharts(this.props)}
      <CompaniesAnalysis riskTypeChange={donutSegmentClick(this.props)}/>
    </div>
  )

  componentDidMount = () => {
    checkAndFetchData(this.props)
  }

  componentWillReceiveProps = (nextProps: Props) => {
    checkAndFetchData(nextProps)
  }
}

const mapStateToProps = (state) => ({
  graphData: portfoliosSelectors.getActivePortfolioGraphData(state),
  l: appSelectors.getL(state),
  portfolioName: portfoliosSelectors.getActivePortfolioName(state),
  riskSummary: portfoliosSelectors.getActivePortfolioRiskSummary(state),
  toggleRiskFilter: path(['ui', 'toggleRiskFilter'], state),
  currentRiskLevel: path(['ui', 'shownRiskRating'], state),
  tabDataFlags: state.app.tabDataFlags,
  isLoading: state.app.showAppLoader,
})

export default connect(
  mapStateToProps,
  mergeAll([appActions, uiActions, portfoliosActions]),
)(RawAnalysisPage)



// WEBPACK FOOTER //
// ./src/views/analysis-page/index.js